import { render } from "./agency.vue?vue&type=template&id=8f3a46f2&scoped=true"
import script from "./agency.vue?vue&type=script&lang=js"
export * from "./agency.vue?vue&type=script&lang=js"

import "./agency.vue?vue&type=style&index=0&id=8f3a46f2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f3a46f2"]])

export default __exports__